import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewUserPageNew from "../../components/User/ViewUserPageNew";
import ViewUserReport from "../../components/UserReport/ViewUserReport";



const ViewUserPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                {/* Breadcrumb */}
                <Breadcrumb id="title" title2="User Report" link2="/user-report" title="View User Report" />

                {/* AddUserLayer */}
                <ViewUserReport />

            </MasterLayout>
        </>
    );
};

export default ViewUserPage;
